import NestedList from "@editorjs/nested-list";

export default class EditorJsCustomList extends NestedList {
    constructor({ data, config, api, block, readOnly }) {
        super({ data, config, api, block, readOnly });
    }

    filterEmptyListItems(list) {
        const clone = list.cloneNode(true); // Clone to avoid modifying the original list
        clone.querySelectorAll("li").forEach((li) => {
            const hasText = [...li.childNodes].some(
                (node) =>
                    node.nodeType === Node.TEXT_NODE &&
                    node.nodeValue.trim().length > 0,
            );
            if (!hasText && li.querySelector("ul, ol")) {
                const parent = li.parentElement;
                const nestedList = li.querySelector("ul, ol");
                // Move each child <li> of the nested list into the parent <ul>
                while (nestedList.firstChild) {
                    parent.insertBefore(nestedList.firstChild, li);
                }
                parent.removeChild(li); // Remove the empty <li>
            }
        });
        // If the top-level <ul> contains only a single <ul>, unwrap it
        while (
            clone.children.length === 1 &&
            clone.firstElementChild.tagName === "UL"
        ) {
            const innerList = clone.firstElementChild;
            clone.replaceChildren(...innerList.children);
        }
        return clone; // Return the sanitized HTML
    }

    /**
     * On paste callback that is fired from Editor.
     * @param event - event with pasted data
     */
    onPaste(event) {
        const { tagName: tag } = event.detail.data;

        // Initialize the list style based on the pasted tag (OL, UL, or LI)
        switch (tag) {
        case "OL":
            this.listStyle = "ordered";
            break;
        case "UL":
        case "LI":
            this.listStyle = "unordered";
        }

        const pastedElement = event.detail.data;
        // If it's a valid HTML structure, query it directly
        if (pastedElement instanceof HTMLElement) {
            event.detail.data = this.filterEmptyListItems(pastedElement);
            super.onPaste(event);
        } else {
            console.log("Pasted content is not a valid HTML element.");
        }
    }
}
